import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../messages';
import { useEmailSupportFeatureGate } from '../../../../feature-gates/use-email-support-feature-gate';
import { getSupportOnlineFormLink } from '../../../../utils/support-online-form-link';

const useSupportOnlineFormItem = (supportCountry) => {
  const { isFeatureEnabled } = useEmailSupportFeatureGate();

  return useMemo(() => {
    if (!isFeatureEnabled) {
      return null;
    }

    const onSupportOnlineFormClicked = (e) => {
      e.stopPropagation();
    };

    const onlineFormItem = {
      url: `${getSupportOnlineFormLink(supportCountry)}`,
      description: <FormattedMessage {...messages.emailFormSupport} />,
      onClick: onSupportOnlineFormClicked,
      rel: 'noopener noreferrer',
      target: '_blank',
      testId: 'support-online-form-item',
    };
    return onlineFormItem;
  }, [isFeatureEnabled, supportCountry]);
};

export default useSupportOnlineFormItem;
